import { render } from "./iframe_view.vue?vue&type=template&id=0a7088e6&scoped=true"
import script from "./iframe_view.vue?vue&type=script&lang=js"
export * from "./iframe_view.vue?vue&type=script&lang=js"

import "./iframe_view.vue?vue&type=style&index=0&id=0a7088e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7088e6"]])

export default __exports__